import {useAtom} from 'jotai';

import {type AccentChoice, accentChoiceAtom} from '@atoms/accent';

export const useAccentChoice = (): [AccentChoice, (next: AccentChoice) => void] => {
  return useAtom(accentChoiceAtom);
};
